import { Stack } from '@mui/material'
import RangeInputs from 'components/cattles/lamenessPage/shared/filterElements/RangeInputs'
import { roundingNumber } from 'components/shared/processes'
import { useState } from 'react'
import DateRangePicker from 'ui/DatePickerInput/DateRangePicker'

import { TypographyPrimary } from 'ui/typography/TypographyPrimary'

const TrimContentBlock = props => {
	const {
		lastTrim,
		availableLastTrimValues,
		handleDayChange,
		setActiveFilters,
	} = props

	const [dateRange, setDateRange] = useState({
		startDate: undefined,
		endDate: undefined,
	})

	const onChangeCallback = value => {
		setDateRange({
			startDate: value[0],
			endDate: value[1],
		})
		setActiveFilters(prev => {
			return {
				...prev,
				dateRange: { startDate: value[0], endDate: value[1] },
			}
		})
	}

	return (
		<Stack direction='column' gap='24px'>
			<Stack direction='column' gap='16px'>
				<TypographyPrimary>
					Количество дней с последней обрезки
				</TypographyPrimary>
				<RangeInputs
					startValue={lastTrim.startOf}
					endValue={lastTrim.endOf}
					availableStart={availableLastTrimValues?.startOf}
					availableEnd={availableLastTrimValues?.endOf}
					formatValue={value => roundingNumber(value, 0)}
					onStartChange={e => handleDayChange(e, 'lastTrim', 'startOf')}
					onEndChange={e => handleDayChange(e, 'lastTrim', 'endOf')}
				/>
			</Stack>
			<Stack direction='column' gap='16px'>
				<TypographyPrimary>Дата или период последней обрезки</TypographyPrimary>
				<DateRangePicker
					onChangeUpdateDate={onChangeCallback}
					startDate={dateRange.startDate}
					endDate={dateRange.endDate}
					isNeedFutureDates
					disabledDates={null}
				/>
			</Stack>
		</Stack>
	)
}

export default TrimContentBlock
